I18n.translations || (I18n.translations = {});
I18n.translations["lt"] = I18n.extend((I18n.translations["lt"] || {}), {
  "actions": "Veiksmai",
  "activerecord": {
    "attributes": {
      "destination": {
        "adress": "Adresas",
        "name": "Pavadinimas"
      },
      "employee": {
        "active": "Aktyvus",
        "admin": "Super teisės",
        "email": "El. paštas",
        "first_name": "Vardas",
        "last_name": "Pavardė",
        "role": "Rolė"
      },
      "explosive": {
        "available": "Prieinamas",
        "box_number": "Dėžės numeris",
        "code": "Vieneto kodas",
        "delivery_date": "Pristatymo data",
        "grouped_number": "Sugrupuotas numeris",
        "import_name": "Importuoto failo pavadinimas",
        "item_number": "Vieneto numeris",
        "location": "Vieta",
        "manufacturer": "Gamintojas",
        "middlebox_number": "Pakuotės numeris",
        "number_type": "Numerio tipas",
        "product_name": "Produkto pavadinimas",
        "product_number": "Produkto numeris",
        "reason": "Priežastis",
        "takeout": "Išėmimas",
        "unknown_type": "Nežinomas tipas"
      },
      "item_setting": {
        "aine_code": "Medžiagos kodas",
        "countable_unit": "Skaičiuojamas vienetas",
        "countable_units": {
          "units": "Vienetai",
          "weight": "Svoris"
        },
        "include_in_waybills": "Įtraukti į važtaraščius",
        "item_count": "Vienetų skaičius",
        "item_name_display": "Pavadinimas ekrane",
        "item_name_import": "Vieneto pavadinimas",
        "manually_created": "Sukurta rankiniu būdu",
        "set_weight_manually": "Rankinis svoris",
        "uro_number": "URO numeris",
        "waybill_position": "Pozicija važtaraštyje",
        "weight": "Svoris"
      },
      "log": {
        "action": "Veiksmas",
        "actions": {
          "atgriešana": "Grąžinimas",
          "dzēšana": "Ištrynimas",
          "izņemšana": "Išėmimas",
          "korekcija": "Korekcija",
          "noliktavas pārvietošana": "Perkėlimas sandėlyje",
          "pievienošana": "Pridėjimas",
          "rediģēšana": "Redagavimas",
          "saņemšana": "Priėmimas",
          "starp-objektu pārvietošana": "Perkėlimas tarp objektų"
        },
        "author": "Vykdytojas",
        "corrected_explosives": "Koreguoti sprogmenys",
        "current_destination": "Dabartinė vieta",
        "date": "Data",
        "destination": "Darbo objektas",
        "destinations": "Darbo objektai",
        "employee": "Darbuotojas",
        "id_number": "ID numeris",
        "import_name": "Importo failas",
        "notes": "Pastabos",
        "takeout": "Išėmimas",
        "takeout_waybill": "Išėmimo važtaraštis",
        "takeout_waybill_custom_items": "Rankiniu būdu pridėta išėmimo važtaraščio eilutė",
        "vehicle": "Transporto priemonė"
      },
      "pdf_code_printout": {
        "code": "Kodas",
        "name": "Pavadinimas",
        "unit": "Mato vienetas",
        "weight": "Svoris"
      },
      "report": {
        "code": "Kodas",
        "name": "Pavadinimas",
        "unit": "Mato vienetas",
        "weight": "Svoris"
      },
      "takeout": {
        "active": "Aktyvus?",
        "date": "Data",
        "destination": "Darbo objektas",
        "employee": "Sukūrėjas",
        "removed": "Ištrintas",
        "vehicle": "Transporto priemonė",
        "waybills": "Važtaraščiai"
      },
      "takeout_waybill": {
        "date": "Data",
        "destination": "Objektas",
        "direction": "Kryptis",
        "employee": "Darbuotojas",
        "initally_edited": "Redaguota",
        "issuance_person": "Išsiuntėjas",
        "issuer": "Išsiuntėjas",
        "legal_entity": "Teisingas asmuo",
        "number": "Numeris",
        "receiver": "Gavėjas",
        "receiving_person": "Gavėjas",
        "route": "Maršrutas",
        "scope": "Važtaraščio objektas",
        "takeout": "Išėmimas",
        "to_object": "Į objektą",
        "vehicle": "Transporto priemonė"
      },
      "takeout_waybill_custom_item": {
        "amount": "Kiekis",
        "item_setting": "Vieneto nustatymai",
        "name": "Pavadinimas",
        "package_name": "Pakuotė",
        "takeout_waybill": "Išėmimo važtaraštis",
        "weight": "Svoris"
      },
      "user": {
        "confirmation_sent_at": "Patvirtinimas išsiųstas",
        "confirmation_token": "Patvirtinimo žymė",
        "confirmed_at": "Patvirtinta",
        "created_at": "Sukurta",
        "current_password": "Dabartinis slaptažodis",
        "current_sign_in_at": "Dabartinis prisijungimas",
        "current_sign_in_ip": "Dabartinio prisijungimo IP",
        "email": "El. paštas",
        "encrypted_password": "Užšifruotas slaptažodis",
        "failed_attempts": "Nepavykę bandymai",
        "last_sign_in_at": "Paskutinį kartą prisijungta",
        "last_sign_in_ip": "Paskutinio prisijungimo IP",
        "locked_at": "Užblokuota",
        "password": "Slaptažodis",
        "password_confirmation": "Slaptažodžio patvirtinimas",
        "remember_created_at": "Priminti mane sukurta",
        "remember_me": "Prisiminti mane",
        "reset_password_sent_at": "Slaptažodžio nustatymas iš naujo išsiųstas",
        "reset_password_token": "Slaptažodžio nustatymo iš naujo žymė",
        "sign_in_count": "Prisijungta kartų",
        "unconfirmed_email": "Nepatvirtintas slaptažodis",
        "unlock_token": "Atblokuoti žymę",
        "updated_at": "Atnaujinta"
      },
      "vehicle": {
        "active": "Aktyvus",
        "number_plate": "Valstybinis numeris"
      },
      "warehouse": {
        "address": "Adresas",
        "city": "Miestas",
        "country_code": "Šalies kodas",
        "latitude": "Platuma",
        "longitude": "Ilguma",
        "name": "Pavadinimas",
        "responsible_person": "Atsakingas asmuo",
        "zip": "Pašto kodas"
      }
    },
    "created_at": "Sukurtas",
    "errors": {
      "destination": {
        "adress_taken": "Nurodytas adresas jau pridėtas",
        "generic_error": "Klaida įvesties duomenyse",
        "name_blank": "Pavadinimas negali būti tuščias"
      },
      "messages": {
        "record_invalid": "Nepraeitos patikros: %{errors}",
        "restrict_dependent_destroy": {
          "has_many": "Negalima ištrinti įrašų nes priklausomi %{record} egzistuoja",
          "has_one": "Negalima ištrinti įrašo nes priklausomas %{record} egzistuoja"
        }
      },
      "takeout": {
        "employee_already_has_identical_takeout": "Darbuotojas jau turi identišką išėmimą",
        "missing_destinations": "Turėtų būti pasirinktas bent vienas darbo objektas"
      },
      "takeout_waybill": {
        "destination_unknown": "Nežinoma"
      }
    },
    "models": {
      "destination": "Darbo objektas",
      "employee": "Darbuotojas",
      "explosive": "Sprogmuo",
      "item_setting": "Vieneto nustatymas",
      "log": "Veiksmų žurnalas",
      "pdf_code_printout": "PDF kodų spaudinys",
      "report": "Ataskaita",
      "takeout": "Sprogmenų išėmimas",
      "takeout_waybill": "Išėmimo važtaraštis",
      "takeout_waybill_custom_item": "Rankiniu būdu įvedamas vienetas",
      "user": {
        "few": null,
        "many": null,
        "one": null,
        "other": null
      },
      "vehicle": "Transporto priemonė",
      "warehouse": "Sandėlis"
    },
    "removed": "Ištrintas",
    "updated_at": "Atnaujintas"
  },
  "auth": {
    "passwords": {
      "edit": {
        "back_to_login": "Grįžti į prisijungimą",
        "description": "Pasirinkite naują slaptažodį savo paskyrai.",
        "password_confirmation_label": "Patvirtinkite naują slaptažodį",
        "password_label": "Naujas slaptažodis",
        "submit": "Atnaujinti slaptažodį",
        "title": "Nustatyti slaptažodį"
      },
      "new": {
        "back_to_login": "Grįžti į prisijungimą",
        "description": "Įveskite darbo el. paštą, kad gautumėte slaptažodžio nustatymo nuorodą.",
        "submit": "Siųsti nuorodą",
        "title": "Gauti slaptažodžio nuorodą"
      }
    },
    "sessions": {
      "new": {
        "auth_divider": "arba",
        "email_login_button": "Prisijungti el. paštu",
        "email_login_title": "Prisijungimas darbo el. paštu",
        "google_auth": "Prisijungti su Google",
        "password_label": "Slaptažodis",
        "password_link_text": "Gauti slaptažodžio nustatymo nuorodą",
        "remember_me": "Prisiminti mane",
        "title": "Prisijungti prie BALROCK sandėlio apskaitos"
      }
    }
  },
  "back": "Atgal",
  "cancel": "Atšaukti",
  "controllers": {
    "application": {
      "not_logged_in": "Turite prisijungti, kad galėtumėte peržiūrėti prašomą puslapį!",
      "not_permitted": "Jūs neturite teisės peržiūrėti prašomo puslapio!",
      "report_ready": "Jūsų ataskaita: %{report_name} paruošta! {link} <br>"
    },
    "auth": {
      "sessions": {
        "invalid_credentials": "Neteisingas el. paštas arba slaptažodis. Patikrinkite duomenis.",
        "no_access": "Jūsų prieiga prie sistemos uždrausta. Susisiekite su administracija.",
        "server_error": "Įvyko serverio klaida. Pabandykite dar kartą."
      }
    },
    "destinations": {
      "object_added": "Objektas sėkmingai pridėtas",
      "object_edited": "Objektas sėkmingai redaguotas"
    },
    "employees": {
      "employee_added": "Darbuotojas sėkmingai pridėtas",
      "employee_added_with_invite": "Darbuotojas pridėtas ir išsiųsta slaptažodžio nustatymo nuoroda",
      "employee_edited": "Darbuotojo duomenys sėkmingai atnaujinti",
      "password_email_failed": "Darbuotojas pridėtas, tačiau nepavyko išsiųsti slaptažodžio nustatymo laiško."
    },
    "explosives": {
      "all_items_moved": "Visi pažymėti vienetai sėkmingai perkelti",
      "all_items_removed": "Visi vienetai sėkmingai pašalinti",
      "all_items_returned": "Visi vienetai sėkmingai grąžinti į sandėlį",
      "database_updated": "Duomenų bazė atnaujinta",
      "failed_import_file_count": "%{count_failed} iš %{count_total} nepavyko importuoti",
      "failed_to_add": "%{count} vienetų nepavyko pridėti",
      "failed_to_import": "Failo %{filename} nepavyko importuoti, nes %{reason}",
      "import_in_progress": "Failas importuojamas. Apie rezultatą būsite informuoti.",
      "item_already_at_destination": "jau paskirties sandėlyje",
      "item_not_found": "nerasta",
      "item_removed": "pašalinta",
      "item_unavailable": "neprieinama",
      "multiple_warehouses": "Klaida! Nuskaityti vienetai yra keliuose sandėliuose, patikslinkite jų numerius.",
      "no_files_selected": "Nepasirinktas joks failas",
      "no_item_settings": "Kai kurie vienetai nėra susieti su nustatymais",
      "no_items_found": "Duotame numerių intervale nerasta nė vieno vieneto",
      "no_warehouse": "--",
      "not_all_items_moved": "Klaida perkeliant vienetus, patikrinkite vienetų sąrašą.",
      "not_all_states_changed": "Įvyko klaida ir kai kurių vienetų būsena nepasikeitė",
      "not_available_for_movement": "Sprogmenų vienetas neprieinamas",
      "partial_items_moved": "Sėkmingai perkelta %{moved} pažymėtų vienetų. %{failed} pažymėtų vienetų nepavyko (pvz. %{examples}).",
      "range_must_be_numeric": "Intervalo pradžia ir pabaiga turi būti skaitinės",
      "range_required": "Įveskite intervalo pradžią ir pabaigą",
      "range_start_after_end": "Intervalo pradžia turi būti mažesnė arba lygi pabaigai",
      "range_too_large": "Intervalas per didelis (maks. %{max} vienetų)",
      "warehouse_not_selected": "Nepasirinktas paskirties sandėlis"
    },
    "item_settings": {
      "created": "Vieneto nustatymai sėkmingai sukurti",
      "deleted": "Vieneto nustatymai sėkmingai ištrinti",
      "edited": "Vieneto nustatymai sėkmingai atnaujinti",
      "failed_to_create": "Klaida kuriant vieneto nustatymus",
      "failed_to_edit": "Klaida atnaujinant vieneto nustatymus",
      "unable_to_delete": "Negalima ištrinti, nes susieta su sprogmenimis"
    },
    "reports": {
      "error": "Įvyko klaida. Prašome bandyti sukurti ataskaitą iš naujo!",
      "no_period": "Nurodykite sprogmenų judėjimo ataskaitos laikotarpį!",
      "no_report": "Ataskaitos failas nerastas!",
      "preparation_error": "Įvyko klaida ruošiant ataskaitą %{report_name}"
    },
    "sessions": {
      "invalid_credentials": "Neteisingas el. paštas arba slaptažodis. Patikrinkite duomenis.",
      "no_access": "Jūsų prieiga prie sistemos uždrausta. Susisiekite su administracija.",
      "server_error": "Įvyko serverio klaida. Pabandykite dar kartą."
    },
    "takeout_waybills": {
      "data_updated": "Važtaraščio duomenys atnaujinti",
      "waybill_edited": "Važtaraštis jau redaguotas"
    },
    "takeouts": {
      "add_back_to_warehouse": "Padėkite vienetus atgal į teisingą sandėlį!",
      "item_not_removed": "Klaida, nepavyko pašalinti vieneto",
      "item_removed": "Vienetas sėkmingai pašalintas",
      "need_more_data": "Prašome patikslinti važtaraščio duomenis",
      "no_access": "Jūs neturite prieigos teisių",
      "no_access_system_error": "Sistemoje įvyko klaida dėl jūsų prieigos teisių autorizacijos",
      "scan_to_next_object_title": "Nuskaitykite vienetus, kuriuos vežate į %{destination}",
      "takeout_confirmation_modal_title": "Ar tikrai norite vykti į %{destination} su vienetais:",
      "takeout_exists": "Klaida! Toks išėmimas jau egzistuoja!",
      "takeout_unavailable": "Išėmimas negalimas",
      "to_next_object_button": "Perkelti į %{destination}"
    },
    "vehicles": {
      "created": "Automobilis sėkmingai pridėtas",
      "edited": "Automobilis sėkmingai redaguotas"
    },
    "warehouses": {
      "unable_to_delete": "Nepavyko ištrinti sandėlio",
      "warehouse_created": "Sandėlis sėkmingai sukurtas",
      "warehouse_deleted": "Sandėlis sėkmingai ištrintas",
      "warehouse_edited": "Sandėlio duomenys sėkmingai atnaujinti"
    }
  },
  "create": "Sukurti",
  "date": {
    "abbr_day_names": [
      "Sek",
      "Pir",
      "Ant",
      "Tre",
      "Ket",
      "Pen",
      "Šeš"
    ],
    "abbr_month_names": [
      null,
      "Sau",
      "Vas",
      "Kov",
      "Bal",
      "Geg",
      "Bir",
      "Lie",
      "Rgp",
      "Rgs",
      "Spa",
      "Lap",
      "Grd"
    ],
    "day_names": [
      "sekmadienis",
      "pirmadienis",
      "antradienis",
      "trečiadienis",
      "ketvirtadienis",
      "penktadienis",
      "šeštadienis"
    ],
    "formats": {
      "default": "%Y-%m-%d",
      "long": "%Y m. %B %d d.",
      "short": "%b %d"
    },
    "month_names": [
      null,
      "sausio",
      "vasario",
      "kovo",
      "balandžio",
      "gegužės",
      "birželio",
      "liepos",
      "rugpjūčio",
      "rugsėjo",
      "spalio",
      "lapkričio",
      "gruodžio"
    ],
    "order": [
      "year",
      "month",
      "day"
    ]
  },
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "few": "apie %{count} valandas",
        "one": "apie %{count} valandą",
        "other": "apie %{count} valandų"
      },
      "about_x_months": {
        "few": "apie %{count} mėnesius",
        "one": "apie %{count} mėnesį",
        "other": "apie %{count} mėnesių"
      },
      "about_x_years": {
        "few": "apie %{count} metus",
        "one": "apie %{count} metus",
        "other": "apie %{count} metų"
      },
      "almost_x_years": {
        "few": "beveik %{count} metai",
        "one": "beveik %{count} metai",
        "other": "beveik %{count} metų"
      },
      "half_a_minute": "pusė minutės",
      "less_than_x_minutes": {
        "few": "mažiau nei %{count} minutės",
        "one": "mažiau nei %{count} minutė",
        "other": "mažiau nei %{count} minučių"
      },
      "less_than_x_seconds": {
        "few": "mažiau nei %{count} sekundės",
        "one": "mažiau nei %{count} sekundė",
        "other": "mažiau nei %{count} sekundžių"
      },
      "over_x_years": {
        "few": "virš %{count} metų",
        "one": "virš %{count} metų",
        "other": "virš %{count} metų"
      },
      "x_days": {
        "few": "%{count} dienos",
        "one": "%{count} diena",
        "other": "%{count} dienų"
      },
      "x_minutes": {
        "few": "%{count} minutės",
        "one": "%{count} minutė",
        "other": "%{count} minučių"
      },
      "x_months": {
        "few": "%{count} mėnesiai",
        "one": "%{count} mėnesis",
        "other": "%{count} mėnesių"
      },
      "x_seconds": {
        "few": "%{count} sekundės",
        "one": "%{count} sekundė",
        "other": "%{count} sekundžių"
      },
      "x_years": {
        "few": "%{count} metai",
        "one": "%{count} metai",
        "other": "%{count} metai"
      }
    },
    "prompts": {
      "day": "Diena",
      "hour": "Valanda",
      "minute": "Minutė",
      "month": "Mėnuo",
      "second": "Sekundės",
      "year": "Metai"
    }
  },
  "delete": "Ištrinti",
  "destinations": {
    "edit": {
      "title": "Objekto redagavimas"
    },
    "form": {
      "adress_note": "Adresas turi būti unikalus.",
      "adress_placeholder": "Objekto adresas",
      "name_placeholder": "Objekto pavadinimas"
    },
    "new": {
      "title": "Naujo objekto pridėjimas"
    }
  },
  "devise": {
    "confirmations": {
      "confirmed": "Jūsų el. pašto adresas sėkmingai patvirtintas.",
      "new": {
        "resend_confirmation_instructions": null
      },
      "send_instructions": "Už keleto minučių sulauksite elektroninio laiško su instrukcijomis kaip patvirtinti jūsų vartotojo paskyrą.",
      "send_paranoid_instructions": "Jei esatę prisiregistravę šiuo e-pašto adresu, už keleto minučių sulauksite elektroninio laiško su instrukcijomis kaip patvirtinti jūsų vartotojo paskyrą"
    },
    "failure": {
      "already_authenticated": "Jūs jau prisijungęs.",
      "inactive": "Jūsų paskyra dar neaktyvuota.",
      "invalid": "Nevalidus slaptažodis arba %{authentication_keys}.",
      "last_attempt": "Jums liko paskutinis bandymas prieš užblokuojant paskyrą.",
      "locked": "Jūsų paskyra laikinai užblokuota.",
      "not_found_in_database": "Nevalidus slaptažodis arba  %{authentication_keys}.",
      "timeout": "Jūsų sesija baigta. Prisijunkite iš naujo norėdami tęsti.",
      "unauthenticated": "Būtina prisijungti arba prisiregistruoti prieš tęsiant.",
      "unconfirmed": "Būtina patvirtinti e-pašto adresą prieš tęsiant."
    },
    "mailer": {
      "confirmation_instructions": {
        "action": "Patvirtinti mano paskyrą",
        "greeting": "Sveiki %{recipient}!",
        "instruction": null,
        "subject": "Paskyros patvirtinimo instrukcijos"
      },
      "email_changed": {
        "greeting": "Sveiki %{recipient}!",
        "message": null,
        "message_unconfirmed": null,
        "subject": "El. paštas pakeistas"
      },
      "password_change": {
        "greeting": "Sveiki %{recipient}!",
        "message": null,
        "subject": "Slaptažodis pakeistas"
      },
      "reset_password_instructions": {
        "action": "Pakeisti mano slaptažodį",
        "greeting": null,
        "instruction": null,
        "instruction_2": null,
        "instruction_3": null,
        "subject": "Slaptažodžio keitimo instrukcijos"
      },
      "unlock_instructions": {
        "action": null,
        "greeting": null,
        "instruction": null,
        "message": null,
        "subject": "Paskyros atblokavimo instrukcijos"
      }
    },
    "omniauth_callbacks": {
      "failure": "Nepavyko autentikaciją per %{kind}, klaida: \"%{reason}\".",
      "success": "Sėkmingai prisijungėte su savo %{kind} paskyra."
    },
    "passwords": {
      "edit": {
        "change_my_password": null,
        "change_your_password": null,
        "confirm_new_password": null,
        "new_password": null
      },
      "new": {
        "forgot_your_password": null,
        "send_me_reset_password_instructions": null
      },
      "no_token": "Jūs negalite pasiekti šio puslapio tiesiogiai, tą turite padaryti iš slaptažodžio keitimo laiško. Jei jūs atėjote naudodami nuorodą, pateiktą slaptažodžio keitimo laiške, įsitikinkite, kad nukopijavote ją visą.",
      "send_instructions": "Jūs gausite el. laišką su slaptažodžio pakeitimo instrukcijomis netrukus.",
      "send_paranoid_instructions": "Jei prisiregistravote šiuo e-pašto adresu, netrukus gausite el. laišką su slaptažodžio pakeitimo instrukcijomis.",
      "updated": "Jūsų slaptažodis pakeistas sėkmingai. Jūs esate prisijungę.",
      "updated_not_active": "Jūsų slaptažodis pakeistas sėkmingai."
    },
    "registrations": {
      "destroyed": "Iki! Jūsų paskyra dabar yra panaikinta. Tikimės, kad ateityje sugrįšite.",
      "edit": {
        "are_you_sure": null,
        "cancel_my_account": null,
        "currently_waiting_confirmation_for_email": null,
        "leave_blank_if_you_don_t_want_to_change_it": null,
        "title": null,
        "unhappy": null,
        "update": null,
        "we_need_your_current_password_to_confirm_your_changes": null
      },
      "new": {
        "sign_up": null
      },
      "signed_up": "Sveiki, jūs sėkmingai prisiregistravote.",
      "signed_up_but_inactive": "Jūs sėkmingai prisiregistravote. Deja dar negalime jūsų prijungti, nes jūsų paskyra nėra aktyvuota.",
      "signed_up_but_locked": "Jūs sėkmingai prisiregistravote. Deja dar negalime jūsų prijungti, nes jūsų paskyra laikinai užblokuota.",
      "signed_up_but_unconfirmed": "El. laiškas buvo išsiųstas jūsų pateiktu adresu. Sekite nuorodą laiške paskyrai aktyvuoti.",
      "update_needs_confirmation": "Jūsų paskyra sėkmingai atnaujinta, tačiau mums reikia patvirtinti jūsų naują el. pašto adresą. Prašome pasitikrinkite savo e-paštą ir sekite instrukcijas laiške.",
      "updated": "Jūsų duomenys sėkmingai atnaujinti.",
      "updated_but_not_signed_in": null
    },
    "sessions": {
      "already_signed_out": "Jau esate atsijungę.",
      "new": {
        "sign_in": null
      },
      "signed_in": "Jūs prisijungėte.",
      "signed_out": "Sėkmingai atsijungėte iš savo paskyros."
    },
    "shared": {
      "links": {
        "back": null,
        "didn_t_receive_confirmation_instructions": null,
        "didn_t_receive_unlock_instructions": null,
        "forgot_your_password": null,
        "sign_in": null,
        "sign_in_with_provider": null,
        "sign_up": null
      },
      "minimum_password_length": {
        "few": null,
        "many": null,
        "one": null,
        "other": null
      }
    },
    "unlocks": {
      "new": {
        "resend_unlock_instructions": null
      },
      "send_instructions": "Netrukus sulauksite el. laiško su instrukcijomis, kaip atblokuoti paskyrą.",
      "send_paranoid_instructions": "Jei registracijai naudojote šį e-pašto adresą, netrukus sulauksite el. laiško su instrukcijomis, kaip atblokuoti paskyrą.",
      "unlocked": "Jūsų paskyra atblokuota. Prisijunkite prie paskyros darbui tęsti."
    }
  },
  "download": "Atsisiųsti",
  "edit": "Redaguoti",
  "edit_object": "Redaguoti",
  "employees": {
    "edit": {
      "title": "Darbuotojo redagavimas"
    },
    "form": {
      "email_note": "El. paštas turi būti @gmail.com arba @balrock.lv.",
      "email_placeholder": "Įveskite darbuotojo el. paštą",
      "first_name_note": "Varde negali būti skaičių.",
      "first_name_placeholder": "Įveskite darbuotojo vardą",
      "last_name_note": "Pavardėje negali būti skaičių.",
      "last_name_placeholder": "Įveskite darbuotojo pavardę"
    },
    "index": {
      "employee_enabled": "Prieiga prie sistemos",
      "subtitle": "Darbuotojų ir prieigos valdymas",
      "title": "Darbuotojai"
    },
    "new": {
      "title": "Naujo darbuotojo pridėjimas"
    }
  },
  "errors": {
    "format": "%{attribute} %{message}",
    "messages": {
      "accepted": "turi būti patvirtintas",
      "already_confirmed": "jau buvo patvirtintas, pamėginkite prisijungti",
      "blank": "negali būti tuščias",
      "confirmation": "neteisingai pakartotas",
      "confirmation_period_expired": "privalo būti patvirtintas per %{period}.",
      "empty": "negali būti tuščias",
      "equal_to": "turi būti lygus %{count}",
      "even": "turi būti lyginis skaičius",
      "exclusion": "yra rezervuotas",
      "expired": "nebegalioja, aktyvuokite naują",
      "greater_than": "turi būti didesnis už %{count}",
      "greater_than_or_equal_to": "turi būti didesnis arba lygus %{count}",
      "in": "turi būti skaičiuje %{count}",
      "inclusion": "nenumatyta reikšmė",
      "invalid": "neteisingas",
      "less_than": "turi būti mažesnis už %{count}",
      "less_than_or_equal_to": "turi būti mažesnis arba lygus %{count}",
      "model_invalid": "Tikrinimo klaida: %{errors}",
      "not_a_number": "ne skaičius",
      "not_an_integer": "privalo būti sveikas skaičius",
      "not_found": "nerastas",
      "not_locked": "nebuvo užblokuota",
      "not_saved": {
        "few": null,
        "many": null,
        "one": null,
        "other": null
      },
      "odd": "turi būti nelyginis skaičius",
      "other_than": "privalo būti kitoks nei %{count}",
      "present": "turi būti tuščias",
      "required": "turi egzistuoti",
      "taken": "jau užimtas",
      "too_long": {
        "few": "per ilgas (daugiausiai %{count} simboliai)",
        "one": "per ilgas (daugiausiai %{count} simbolis)",
        "other": "per ilgas (daugiausiai %{count} simbolių)"
      },
      "too_short": {
        "few": "per trumpas (mažiausiai %{count} simboliai)",
        "one": "per trumpas (mažiausiai %{count} simbolis)",
        "other": "per trumpas (mažiausiai %{count} simbolių)"
      },
      "wrong_length": {
        "few": "neteisingo ilgio (turi būti %{count} simboliai)",
        "one": "neteisingo ilgio (turi būti %{count} simbolis)",
        "other": "neteisingo ilgio (turi būti %{count} simbolių)"
      }
    },
    "template": {
      "body": "Šiuose laukuose yra klaidų:",
      "header": {
        "few": "Išsaugant objektą %{model} rastos %{count} klaidos",
        "one": "Išsaugant objektą %{model} rasta %{count} klaida",
        "other": "Išsaugant objektą %{model} rasta %{count} klaidų"
      }
    }
  },
  "explosive_unit": "Vienetas",
  "explosives": {
    "amount_correction": {
      "no_camera_alert": "Kamera nepasiekiama!",
      "no_camera_alert_message": "Gali būti, kad nesuteikėte leidimo ją naudoti, arba išjungėte javascript.",
      "subtitle": "Nuskaitykite kodą arba įveskite numerį ir pasirinkite tolimesnį veiksmą",
      "title": "Sprogmenų kiekio korekcija"
    },
    "index": {
      "title": "Klaidingi įrašai"
    },
    "location": {
      "removed": "-- (Manuāli Ištrinta)",
      "used": "Panaudota - %{destination_name}",
      "warehouse": "Sandėlis"
    },
    "new": {
      "drop_files": "Nutempkite failus čia",
      "import": "Importuoti",
      "upload_note": "Pasirinkite vieną ar daugiau .xml arba .xlsx failų."
    },
    "warehouse_movement": {
      "entry_mode_label": "Įvedimo režimas",
      "no_camera_alert": "Kamera nepasiekiama!",
      "no_camera_alert_message": "Gali būti, kad nesuteikėte leidimo ją naudoti, arba išjungėte javascript.",
      "process_range": "Apdoroti intervalą",
      "range_end": "Intervalo pabaiga",
      "range_end_placeholder": "pvz. 275998",
      "range_entry": "Intervalo įvedimas",
      "range_entry_title": "Intervalo įvedimas:",
      "range_start": "Intervalo pradžia",
      "range_start_placeholder": "pvz. 275961",
      "single_entry": "Vienetinis įvedimas",
      "subtitle": "Pasirinkite sandėlį, į kurį pridėti sprogmenis, tada nuskaitykite kodą arba įveskite numerį",
      "title": "Sprogmenų perkėlimas tarp sandėlių",
      "warehouse_select_label": "Sandėlis, į kurį pridėti",
      "warehouse_select_placeholder": "Pasirinkite sandėlį"
    }
  },
  "helpers": {
    "select": {
      "prompt": "Prašom pasirinkti"
    },
    "submit": {
      "create": "Sukurti %{model}",
      "submit": "Išsaugoti %{model}",
      "update": "Atnaujinti %{model}"
    }
  },
  "i18n": {
    "plural": {
      "keys": [
        "one",
        "few",
        "other"
      ],
      "rule": "#<Proc:0x00007fc57e614978 /usr/local/bundle/gems/rails-i18n-7.0.10/lib/rails_i18n/pluralization.rb:66 (lambda)>"
    }
  },
  "item_settings": {
    "index": {
      "subtitle": "Vienetų svorio ir važtaraščių nustatymai",
      "title": "Vienetų nustatymai"
    },
    "item_setting_row": {
      "weight_note": "Numatytasis svoris"
    }
  },
  "javascript": {
    "alert_modal": {
      "error": "Klaida!"
    },
    "correction_code_scanner": {
      "camera_alert": "Kamera nepasiekiama!",
      "correction_modal_title": "Kiekio korekcija",
      "explosive_type": "Sprogmuo",
      "explosive_units": "vienetai",
      "no_camera_permission": "Galbūt nesuteikėte leidimo ją naudoti, arba išjungėte javascript.",
      "remove_explosives": "Ištrinti iš sandėlio",
      "revive_explosives": "Grąžinti į apskaitą (be sandėlio)",
      "some_units_deleted": "tačiau kai kurie iš jame buvusių vienetų jau ištrinti.",
      "which_has": ", kuriame yra "
    },
    "file_upload": {
      "files_selected": " failai pasirinkti",
      "import_notification": "Duomenys importuojami, prašome palaukti."
    },
    "item_settings": {
      "success": "Viskas pavyko"
    },
    "loading_screen": {
      "please_wait": "Prašome palaukti..."
    },
    "takeout_code_scanner": {
      "add_range_items": "Pridėti pasirinktus vienetus",
      "already_scanned": "Kodas jau nuskaitytas",
      "camera_off": "Kamera išjungta!",
      "confirm_scanned_items": "Patvirtinu, kad nuskaityti vienetai ir jų statusai atitinka tikrovę",
      "confirm_used_items": "Patvirtinu, kad visi išimti vienetai buvo panaudoti objekte",
      "error_occurred": "Įvyko klaida",
      "failed_to_remove_item": "Klaida šalinant vienetą. Bandykite dar kartą arba susisiekite su administratoriumi!",
      "item_already_scanned": "Vienetas (-ai) jau nuskaitytas.",
      "item_returnable": "Grąžinama",
      "item_used": "Panaudota",
      "items_return_confirmation": "Ar norite grąžinti šiuos vienetus?",
      "items_take_confirmation": "Ar norite išimti šiuos vienetus?",
      "no_items_scanned": "Nėra nuskaitų vienetų",
      "range_modal_title": "Pridėti vienetus iš intervalo",
      "refresh_for_camera": "Norėdami vėl įjungti kamerą, turite atnaujinti puslapį!",
      "return_scanned": "Nuskaityti vienetai bus laikomi grąžintais į sandėlį.",
      "scan_returnable_items": "Grąžintų vienetų nuskaitymas",
      "scan_used_items": "Panaudotų vienetų nuskaitymo režimas",
      "writeoff_scanned": "Nuskaityti vienetai bus laikomi panaudotais objekte. !! Bus grąžinti visi išimti vienetai, esantys toje pačioje pakuotėje su nuskaitytu vienetu !!"
    },
    "warehouse_movement": {
      "confirm_move": "Patvirtinti perkėlimą",
      "current_warehouse_name": "Sandėlis",
      "explosive_type": "Sprogmuo",
      "explosive_units": "vienetai",
      "from_warehouse": "Iš %{warehouse}",
      "included_ids": "Įtraukti ID (%{included} / %{total})",
      "items_badge": "%{count} vienetai",
      "modal_title": "Sprogmenų perkėlimas tarp sandėlių",
      "modal_title_short": "Sprogmenų perkėlimas",
      "move_error": "Klaida perkeliant vienetus, patikrinkite vienetų sąrašą.",
      "move_success": "Sprogmenys sėkmingai perkelti",
      "move_to_button": "Perkelti",
      "move_warehouse_info": "Perkelti iš #{from} į #{to}",
      "no_items_found": "Duotame numerių intervale nerasta nė vieno vieneto",
      "no_items_selected": "Pasirinkite bent vieną vienetą perkėlimui",
      "range_failures_preview": "%{count} vienetų perkelti negalima (pvz. %{examples}).",
      "range_label": "Intervalas: %{start} → %{end}",
      "range_must_be_numeric": "Intervalo pradžia ir pabaiga turi būti skaitinės",
      "range_required": "Įveskite intervalo pradžią ir pabaigą",
      "range_start_after_end": "Intervalo pradžia turi būti mažesnė arba lygi pabaigai",
      "some_units_deleted": "tačiau kai kurie iš jame buvusių vienetų jau ištrinti.",
      "subtitle_range": "Pasirinkite paskirties sandėlį, tada įveskite arba nuskaitykite numerių intervalą",
      "to_warehouse": "Į %{warehouse}",
      "total_items": "%{count} vienetai",
      "total_weight": "%{weight} kg",
      "warehouse_not_selected": "Nepasirinktas sandėlis, į kurį perkelti",
      "which_has": ", kuriame yra "
    }
  },
  "layouts": {
    "alert_modal": {
      "confirm": "Supratau",
      "title": "Klaida!"
    },
    "application": {
      "title": "Balrock sandėlio apskaita"
    },
    "camera_switch": {
      "use_camera": "Naudoti kamerą"
    },
    "confirmation_modal": {
      "confirm": "Patvirtinti",
      "confirmation": "Ar panaudojote visus išimtus vienetus?",
      "title": "Patvirtinimas"
    },
    "delete_modal": {
      "confirmation": "Ar tikrai norite ištrinti %{deletable_object}?",
      "title": "Ištrynimo patvirtinimas"
    },
    "external_scanner": {
      "item_number_placeholder": "Įveskite numerį rankiniu būdu",
      "search": "Ieškoti",
      "title": "Rankinis įvedimas arba skenavimas išoriniu skaitytuvu:"
    },
    "loading_overlay": {
      "please_wait": "Prašome palaukti..."
    },
    "sidebar": {
      "additional_code_printouts": "Papildomų kodų spausdinimas",
      "back": "Atgal",
      "correction": "Kiekio korekcija",
      "home": "Pradinis puslapis",
      "language": "Kalba",
      "logout": "Atsijungti",
      "logs": "Įvykių sąrašas",
      "menu": "Meniu",
      "receive_explosives": "Priėmimas",
      "reports": "Ataskaitos",
      "return": "Grąžinimas",
      "settings": {
        "destinations": "Objektai",
        "employees": "Darbuotojai",
        "item_settings": "Vienetų nustatymai",
        "title": "Nustatymai",
        "vehicles": "Transporto priemonės"
      },
      "takeout": "Išėmimas",
      "title": "Balrock sprogmenų sandėlis",
      "warehouse_movement": "Sandėlių perkėlimas",
      "warehouses": "Sandėliai",
      "waybills": "Važtaraščiai"
    },
    "warehouse_selection_modal": {
      "add_consolidated_report": "Apvienota ataskaita (visi sandėliai)",
      "description": "Prašome pasirinkti, kuriuos sandėlius įtraukti į ataskaitą:",
      "prepare_report": "Paruošti ataskaitą",
      "title": "Pasirinkite sandėlius"
    }
  },
  "logs": {
    "corrected_explosives": {
      "corrected_amount": "Koreguotų vienetų skaičius:",
      "corrected_explosives_table": "Koreguoti sprogmenys",
      "correction_action": "Korekcijos veiksmas:",
      "correction_date": "Data:",
      "deletion": "❌ Ištrynimas",
      "employee": "Korekcijos atlikėjas:",
      "return": "✅ Grąžinimas į sandėlį",
      "title": "Sprogmenų korekcijų ataskaita"
    },
    "helper_row": {
      "changes": "Pakeitimai",
      "corrected_explosives_count": "Koreguotų sprogmenų skaičius",
      "correction_action": "Korekcijos veiksmas",
      "deletion": "Ištrynimas",
      "edited": "Redaguotas",
      "edited_object": "Redaguotas objektas",
      "error": "Įvyko klaida",
      "imported_explosives_count": "Pridėtų sprogmenų skaičius",
      "moved_between": "Perkelta tarp",
      "moved_explosives_count": "Perkeltų vienetų skaičius",
      "movement_route": "Perkėlimo maršrutas",
      "precise_time": "Tikslus laikas",
      "return": "Grąžinimas į sandėlį",
      "returned_explosives_count": "Grąžintų sprogmenų skaičius",
      "taken_explosives_count": "Išimtų sprogmenų skaičius",
      "takeout_responsible_employee": "Atsakingas už išėmimą (sukūrėjas)",
      "to_overview": "Į apžvalgą",
      "used_explosives_count": "Panaudotų sprogmenų skaičius",
      "used_explosives_weight": "Panaudotų sprogmenų svoris"
    },
    "index": {
      "filtering": "Filtravimas",
      "subtitle": "Įvykiai išrikiuoti mažėjančia tvarka pagal jų amžių",
      "title": "Veiksmų žurnalas"
    },
    "log_querry": {
      "clear_filters": "Išvalyti filtrus",
      "filter": "Filtruoti"
    },
    "log_table": {
      "no_results": "Pagal nurodytus kriterijus nieko nerasta"
    },
    "warehouse_moved_explosives": {
      "employee": "Perkėlė:",
      "moved_between": "Perkelta tarp",
      "moved_explosives_count": "Perkeltų vienetų skaičius",
      "moved_explosives_table": "Perkelti sprogmenys",
      "movement_date": "Data:",
      "title": "Sprogmenų perkėlimas tarp sandėlių"
    }
  },
  "main": {
    "index": {
      "active_takeouts": "Aktyvūs sprogmenų išėmimai:",
      "current_employee": "Naudotojas:",
      "employee_admin": "Administratorius",
      "employee_regular": "Darbuotojas",
      "employee_role": "Statusas:",
      "explosives_in_warehouse": "Sprogmenų kiekis sandėlyje:",
      "no_actions": "Jūs dar neatlikote jokių veiksmų.",
      "previous_actions": "Jūsų paskutiniai veiksmai:",
      "title": "Balrock sprogmenų sandėlio apskaita"
    }
  },
  "new_object": "Pridėti",
  "number": {
    "currency": {
      "format": {
        "delimiter": " ",
        "format": "%n %u",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "€"
      }
    },
    "format": {
      "delimiter": " ",
      "precision": 3,
      "round_mode": "default",
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": {
            "few": "Milijardai",
            "one": "Milijardas",
            "other": "Milijardų"
          },
          "million": {
            "few": "Milijonai",
            "one": "Milijonas",
            "other": "Milijonų"
          },
          "quadrillion": {
            "few": "Kvadrilijonai",
            "one": "Kvadrilijonas",
            "other": "Kvadrilijonų"
          },
          "thousand": {
            "few": "Tūkstančiai",
            "one": "Tūkstantis",
            "other": "Tūkstančių"
          },
          "trillion": {
            "few": "Trilijonai",
            "one": "Trilijonas",
            "other": "Trilijonų"
          },
          "unit": {
            "few": "",
            "one": "",
            "other": ""
          }
        }
      },
      "format": {
        "delimiter": "",
        "precision": 1,
        "significant": true,
        "strip_insignificant_zeros": true
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "few": "Baitai",
            "one": "Baitas",
            "other": "Baitų"
          },
          "eb": "EB",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "pb": "PB",
          "tb": "TB"
        }
      }
    },
    "nth": {
      "ordinalized": "%{number}.",
      "ordinals": "."
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%"
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "pagy": {
    "combo_nav_js": "Puslapis %{page_input} iš %{pages}",
    "info": {
      "multiple_pages": "Rodomi %{item_name} <b>%{from}–%{to}</b> iš viso <b>%{count}</b>",
      "no_items": "%{item_name} nerasta",
      "single_page": "Rodomas <b>%{count}</b> %{item_name}"
    },
    "item_name": {
      "one": "Įrašas",
      "other": "Įrašai"
    },
    "items_selector_js": "Į puslapį įtraukti %{items_input} %{item_name} įrašus",
    "nav": {
      "gap": "&hellip;",
      "next": "Kitas&nbsp;&rsaquo;",
      "prev": "&lsaquo;&nbsp;Ankstesnis"
    }
  },
  "pdf_code_printouts": {
    "generator": {
      "generation_failed": "Nepavyko sukurti spausdinamų kodų",
      "invalid_code_type": "Neteisingas vieneto kodo tipas"
    },
    "index": {
      "no_results": "Nieko nerasta",
      "package_search": "Spausdinamų vienetų dėžių paieška pagal pavadinimą",
      "package_search_placeholder": "Pavadinimas arba jo dalis",
      "search": "Ieškoti",
      "title": "Vienetų kodų dublikatų spausdinimas"
    },
    "table_row": {
      "get_pdf": "Gauti PDF kodų lapą"
    }
  },
  "remove": "Pašalinti",
  "reports": {
    "index": {
      "available_explosives_count": "Šiuo metu prieinami %{count} vienetai",
      "available_explosives_report": "Turimi sprogmenys",
      "date_range": "Laikotarpis",
      "explosive_movement_report": "Sprogmenų judėjimas per laikotarpį",
      "explosive_summary": "Sprogmenų likučiai sandėlyje pagal pavadinimą",
      "explosives_in_warehouse": "Sandėlyje yra šie vienetai:",
      "prepare_report": "Paruošti",
      "tab_all": "Visi",
      "tab_without_warehouse": "Be sandėlio",
      "title": "Galimos sistemos ataskaitos .xlsx formatu"
    },
    "quick_report_tab": {
      "total_amount": "Viso:",
      "units": "Vnt.",
      "weight_unit": "kg"
    },
    "xlsx": {
      "available_explosives": {
        "xlsx": {
          "axlsx": {
            "consolidated_headers": [
              "Kodas",
              "Gamintojas",
              "Pavadinimas",
              "Dėžės numeris",
              "Pakuotės numeris",
              "Vieneto numeris",
              "URO numeris",
              "AINE kodas",
              "Importo failas",
              "Vieta",
              "Atsakingas"
            ],
            "no_employee": "Vienetui nepriskirtas atsakingas asmuo",
            "report_row_title": "Turimų sprogmenų ataskaita %{date}",
            "report_warehouse_row_title": "Turimų sprogmenų ataskaita sandėlyje %{warehouse} - %{date}",
            "warehouse_headers": [
              "Kodas",
              "Gamintojas",
              "Pavadinimas",
              "Dėžės numeris",
              "Pakuotės numeris",
              "Vieneto numeris",
              "URO numeris",
              "AINE kodas",
              "Importo failas",
              "Atsakingas"
            ],
            "worksheet_title": "Turimi sprogmenys"
          }
        }
      },
      "explosive_movement": {
        "xlsx": {
          "axlsx": {
            "sheet_name": {
              "active": "AktyvusIšėmimas-%{index}-%{date}",
              "returned": "GrąžintasIšėmimas-%{index}-%{date}"
            },
            "states": {
              "active": "išimta",
              "returned": "grąžinta",
              "used": "panaudota"
            },
            "takeout_explosives_headers": [
              "Kodas",
              "Pavadinimas",
              "Dėžė",
              "Pakuotė",
              "Sprogmuo",
              "Importo failas",
              "Statusas"
            ],
            "takeout_info_headers": [
              "Darbuotojas",
              "Darbo objektas",
              "Transporto priemonė",
              "Statusas",
              "Išimtų vienetų skaičius",
              "Panaudotų vienetų skaičius"
            ],
            "worksheet_title": "Sprogmenų išėmimo/grąžinimo ataskaita"
          }
        }
      }
    }
  },
  "roles": {
    "driver": "Vairuotojas",
    "employee": "Darbuotojas",
    "manager": "Vadovas"
  },
  "save": "Išsaugoti",
  "services": {
    "takeouts": {
      "return_explosives": {
        "all_returned": "Visi vienetai sėkmingai nurašyti!",
        "failed_to_return": "{count} vienetų nepavyko grąžinti.",
        "returned": "Vienetai sėkmingai grąžinti!",
        "server_error": "Serverio klaida grąžinant vienetus!"
      },
      "take_explosives": {
        "failed_to_take": "{count} vienetų nepavyko paimti.",
        "server_error": "Serverio klaida paimant vienetus!",
        "success": "Vienetai sėkmingai paimti"
      },
      "type": "Sprogmuo"
    }
  },
  "shared": {
    "explosives_without_warehouse_block": {
      "add_to_warehouse": "Pridėti į sandėlį",
      "expand": "Išskleisti",
      "title": "Sprogmenys be sandėlio"
    }
  },
  "state": "Įjungta",
  "support": {
    "array": {
      "last_word_connector": " ir ",
      "two_words_connector": " ir ",
      "words_connector": ", "
    }
  },
  "takeout_waybills": {
    "button_title_from": "Važtaraštis IŠ",
    "button_title_to": "Važtaraštis Į",
    "custom_item_form_row": {
      "not_included_in_waybill": "Šis vienetas neįtrauktas į važtaraštį"
    },
    "edit": {
      "manual_items": "Rankiniu būdu įvedami vienetai",
      "title": "Važtaraščio %{number} redagavimas",
      "view_waybill": "Peržiūrėti važtaraštį",
      "waybill_persons": "Važtaraščio asmenys"
    },
    "index": {
      "subtitle": "Visų sukurtų važtaraščių sąrašas",
      "title": "Važtaraščiai"
    },
    "pdf": {
      "default_packaging_type": "kartoninė dėžė",
      "failed_to_create": "Nepavyko sukurti važtaraščio",
      "header": {
        "date": "Data",
        "route": "Maršrutas",
        "waybill": "Važtaraštis",
        "waybill_nr": "VAŽTARAŠTIS nr."
      },
      "item_counts": {
        "kogus": "Kiekis",
        "laohoidja": "Sandėlininkas:",
        "seeria_nr": "Paimta:",
        "tagastus": "Grąžinimas:",
        "vedaja_lohkaja": "Vežėjas/Sprogdintojas/Sprogdinimo meistras:",
        "veokiri_nr": "VAŽTARAŠTIS nr:"
      },
      "legal_entity": {
        "address": "Adresas",
        "reg_number": "Įm. kodas",
        "title": "Teisingas asmuo",
        "vat_number": "PVM mok. kodas"
      },
      "no_custom_item_data": "Nepavyko sukurti važtaraščio, nes visiems jame esantiems vienetams nenurodytas svoris",
      "sender_receiver": "Siuntėjas/Gavėjas:",
      "signatures": {
        "carrier_received": "Medžiagą priėmė vežėjas:",
        "carrier_returned": "Medžiagos likutį sandėlininkui grąžino vežėjas:",
        "carrier_title": "Vežėjas:",
        "date": "Data:",
        "issuer_title": "Už prekių išdavimą atsakingi asmenys:",
        "miner_received": "Medžiagą iš vežėjo priėmė sprogdintojas:",
        "miner_returned": "Medžiagos likutį vežėjui grąžino sprogdintojas:",
        "name": "Vardas, Pavardė:",
        "name_signature_date": "vardas, parašas, data",
        "receiver_title": "Už prekių priėmimą atsakingi asmenys:",
        "responsible_title": "Atsakingas asmuo:",
        "signature": "Parašas:",
        "warehouse_keeper_issued": "Važtaraštį surašė ir medžiagą išdavė sandėlininkas",
        "warehouse_keeper_received": "Medžiagos likutį priėmė sandėlininkas:"
      },
      "table": {
        "aine_code": "Medžiagos kodas",
        "consumption": "Suvartojimas\nkg/vnt./m",
        "description": "Aprašymas",
        "name": "Pavadinimas",
        "package_count": "Pakuočių skaičius (vnt.)",
        "packaging": "Pakuotė",
        "quantity": "Kiekis (vnt.)",
        "remainder": "Likutis\nkg/vnt./m",
        "source_warehouse": "Sandėlis",
        "substance_code": "Medžiagos kodas",
        "substance_name_description": "Medžiagos pavadinimas ir aprašymas",
        "taken": "Paimta\nkg/vnt./m",
        "total": "Viso:",
        "total_weight": "Bendras svoris (kg):",
        "uro_number": "URO nr.",
        "weight_kg": "Svoris (kg)"
      },
      "total_cargo": "Bendras krovinio kiekis:",
      "transport": {
        "self_transport": "savaeigis transportas",
        "type": "Vežimo būdas",
        "vehicle_reg": "Transporto priemonės reg. nr."
      },
      "units": {
        "kg": "kg",
        "pcs": "vnt."
      }
    },
    "table_row": {
      "to_destination": "Į objektą",
      "to_warehouse": "Į sandėlį"
    }
  },
  "takeouts": {
    "explosive_summary": {
      "unit": "vnt."
    },
    "index": {
      "active_title": "Aktyvūs išėmimai (vykdomi)",
      "cta": "Spauskite ant kurios nors, arba sukurkite naują!",
      "historical_title": "Pabaigti išėmimai (paskutiniai 50)",
      "new_takeout": "Naujas išėmimas",
      "no_active_takeouts": "Nėra aktyvių išėmimų.",
      "no_historical_takeouts": "Kol kas nėra pabaigtų išėmimų.",
      "no_takeouts": "Kol kas nėra jokių išėmimų.",
      "type": "Išėmimas"
    },
    "new": {
      "add_destination": "Pridėti",
      "choose_destination": "Pasirinkite darbo objektą",
      "choose_vehicle": "Pasirinkite transporto priemonę",
      "destinations": "Darbo objektai",
      "drag_to_reorder": "Vilkite, kad pakeistumėte tvarką",
      "mandatory_field": "Šis laukas yra privalomas"
    },
    "returns": {
      "p_text": "Spustelėkite atitinkamą išėmimą, kad atliktumėte grąžinimą",
      "return": "Grąžinimas"
    },
    "scan_between_objects_explosives": {
      "available_units_title": "Prieinami vienetai:"
    },
    "scan_return_explosives": {
      "remaining_units_title": "Likusieji vienetai:",
      "title": "Nurašyti visus likusius sprogmenis"
    },
    "scan_takeout_explosives": {
      "title": "Išimti pasirinktus sprogmenis"
    },
    "scanner": {
      "delete_takeout": "Ištrinti išėmimą",
      "destination": "Objektas: %{destination}",
      "item_count": "Vienetų skaičius: %{count}",
      "no_camera_alert": "Kamera nepasiekiama",
      "no_camera_subalert": "Galbūt nesuteikėte leidimo naudoti kamerą",
      "scan_only_used_explosives": "Pasirinkti <strong>tik</strong> objekte panaudotus vienetus",
      "scanned": "Nuskaityta:",
      "this_takeout": "šį išėmimą",
      "title": "Pakuočių kodų nuskaitymas",
      "vehicle": "Transporto priemonė: %{vehicle}"
    },
    "show": {
      "active_takeout": "✅ - Aktyvus",
      "date": "Data:",
      "destination": "Darbo objektas:",
      "employee": "Atsakingas už išėmimą:",
      "inactive_takeout": "❌ - Neaktyvus/Grąžintas",
      "state": "Statusas:",
      "subtitle": "*Lentelę galima slinkti horizontaliai naudojant siaurą mobilųjį įrenginį",
      "title": "Sprogmenų išėmimo/grąžinimo ataskaita",
      "title_2": "Išimti sprogmenų vienetai",
      "title_3": "Panaudoti sprogmenų vienetai paryškinti raudonai",
      "vehicle": "Transporto priemonė:"
    },
    "table": {
      "button_edit_return": "Redaguoti",
      "button_return_to_warehouse": "Grąžinti į sandėlį",
      "button_take_out": "Išimti",
      "button_to_next_object": "Į kitą objektą",
      "items": "%{count} vienetai",
      "title": "Sprogmenų %{action}"
    },
    "taken_explosives": {
      "no_person": "Vienetui nepriskirtas atsakingas asmuo",
      "person": "Asmuo, išėmęs prekę: %{name}",
      "title": "Išimti vienetai:",
      "unknown": "nežinoma"
    }
  },
  "time": {
    "am": "am",
    "formats": {
      "default": "%a, %d %b %Y %H:%M:%S %z",
      "long": "%Y %B %d %H:%M",
      "short": "%d %b %H:%M"
    },
    "pm": "pm"
  },
  "vehicles": {
    "edit": {
      "title": "Automobilio redagavimas"
    },
    "form": {
      "number_plate_placeholder": "AA-XXXX",
      "number_plate_small_text": "Svarbu išlaikyti valstybinio numerio formatą"
    },
    "index": {
      "delete_modal_text": "transporto priemonę %{number_plate}",
      "subtitle": "Transporto priemonių, galinčių vežti sprogmenis, valdymas",
      "title": "Transporto priemonės"
    },
    "new": {
      "title": "Naujo automobilio pridėjimas"
    }
  },
  "view": "Peržiūrėti",
  "warehouses": {
    "edit": {
      "title": "%{warehouse_name} redagavimas"
    },
    "form": {
      "country_code_hint": "Naudokite ISO 3166-1 alpha-2 kodą, pvz., LV.",
      "latitude_hint": "Naudokite platumą, pvz., 56.96130.",
      "longitude_hint": "Naudokite ilgumą, pvz., 24.12540.",
      "responsible_person_prompt": "Pasirinkite atsakingą asmenį"
    },
    "index": {
      "subtitle": "Sandėlių sąrašas ir valdymas",
      "title": "Sandėliai"
    },
    "new": {
      "title": "Naujo sandėlio pridėjimas"
    },
    "show": {
      "details_title": "Sandėlio informacija",
      "explosives_title": "Sandėlyje esantys sprogmenys",
      "map_title": "Vieta žemėlapyje",
      "no_explosives": "Šiame sandėlyje šiuo metu nėra sprogmenų."
    }
  }
});
I18n.translations["en"] = I18n.extend((I18n.translations["en"] || {}), {
});
I18n.translations["lv"] = I18n.extend((I18n.translations["lv"] || {}), {
});
I18n.translations["ru"] = I18n.extend((I18n.translations["ru"] || {}), {
});
I18n.translations["ee"] = I18n.extend((I18n.translations["ee"] || {}), {
});
